<template>

  <svg t="1728368327237" class="icon" viewBox="0 0 1024 1024" version="1.1" xmlns="http://www.w3.org/2000/svg"
       p-id="6089" id="mx_n_1728368327238" xmlns:xlink="http://www.w3.org/1999/xlink" width="200" height="200">
    <path
        d="M838.4 0H192c-42.24 0-76.8 34.56-76.8 76.8v870.4c0 42.24 34.56 76.8 76.8 76.8h646.4c42.24 0 76.8-34.56 76.8-76.8V76.8c0-42.24-34.56-76.8-76.8-76.8z m-121.6 710.4H320c-17.664 0-32-14.336-32-32s14.336-32 32-32h396.8c17.664 0 32 14.336 32 32s-14.336 32-32 32z m0-179.2H320c-17.664 0-32-14.336-32-32s14.336-32 32-32h396.8c17.664 0 32 14.336 32 32s-14.336 32-32 32z m0-179.2H320c-17.664 0-32-14.336-32-32s14.336-32 32-32h396.8c17.664 0 32 14.336 32 32s-14.336 32-32 32z"
        p-id="6090"></path>
  </svg>

</template>

<script lang="ts">
export default {
  name: 'orderIcon'
}
</script>